import { render, staticRenderFns } from "./InnovationBlock.vue?vue&type=template&id=51841e7a&scoped=true"
import script from "./InnovationBlock.vue?vue&type=script&lang=js"
export * from "./InnovationBlock.vue?vue&type=script&lang=js"
import style0 from "./InnovationBlock.vue?vue&type=style&index=0&id=51841e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51841e7a",
  null
  
)

export default component.exports